'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hourAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/hourAfter.js
// module id = 676
// module chunks = 0